<template>
	<div :class="classes">
		<ConfirmationDialog>
			<template v-slot:header>
				<h1 class="trial-end-dialog__title">
					{{ $t( "common.TrialEndDialog_title" ) }}
				</h1>
			</template>
			<template v-slot:description>
				<div
					class="trial-end-dialog__body"
					v-html="$t(`common.TrialEndDialog_bodyHTML`)"
					@click="onBodyClick"
				/>
			</template>
			<template v-slot:actions>
				<TeamingButton
					@click="onSubscribeClick"
				>
					{{ $t( "common.TrialEndDialog_subscribeNowButton" ) }}
				</TeamingButton>
			</template>
		</ConfirmationDialog>
	</div>
</template>

<script>
import ConfirmationDialog from "./dialogs/ConfirmationDialog.vue";
import TeamingButton from "./buttons/TeamingButton.vue";
export default {
	name: "TrialEndDialog",
	emits: [ "schedule", "chat", "subscribe", ],
	components: {
		ConfirmationDialog,
		TeamingButton,
	},
	props: {
		className: {
			type: String,
			default: "",
		},
	},
	computed: {
		classes() {
			return `trial-end-dialog ${ this.className }`.trim();
		},
	},
	methods: {
		onBodyClick( e ) {
			e.preventDefault();
			e.stopPropagation();
			const action = e.target.getAttribute( "data-action" );
			if ( !action ) {
				return;
			}
			this.$emit( action ); // schedule|chat
		},
		onSubscribeClick() {
			this.$emit( "subscribe" );
		},
	},
};
</script>

<style lang="scss" scoped>
.trial-end-dialog {
	position: fixed;
	top: 0;
	left: 0;
	bottom: 0;
	width: 100%;
	background-color: $trial-end-dialog-overlay-color;
	z-index: 9999;
}

.trial-end-dialog__title {
	@include font-and-line-for(2);
	color: $trial-end-dialog-title-color;
}

.trial-end-dialog__body {
	display: flex;
	flex-direction: column;
	gap: 1rem;
	@include font-and-line-for(0);

	color: $trial-end-dialog-body-color;

	a {
		color: $trial-end-dialog-link-color;
	}
}
</style>
